import {
    StyledModalDescription,
    StyledModalHeader,
} from "app/pages/sales-intelligence/pages/manage-signals/components/ApplyTopicModal/styles";
import { ButtonGroup } from "pro-features/components/ButtonsGroup/src/ButtonsGroup";
import { Button, ButtonLabel } from "@similarweb/ui-components";
import type { FC } from "react";

type ModalContentProps = {
    title: string;
    description: string;
    cancelButtonText?: string;
    onCancelClick?: () => void;
    applyButtonText?: string;
    onClick: () => void;
};

const TermsAndConditionsContent: FC<ModalContentProps> = ({
    title,
    description,
    cancelButtonText,
    onCancelClick,
    applyButtonText,
    onClick,
}) => {
    return (
        <>
            <StyledModalHeader>{title}</StyledModalHeader>
            <StyledModalDescription dangerouslySetInnerHTML={{ __html: description }} />
            <ButtonGroup>
                {cancelButtonText ? <Button
                        type={"flat"}
                        onClick={onCancelClick}
                    >
                        <ButtonLabel>{cancelButtonText}</ButtonLabel>
                    </Button> : null}
                {applyButtonText ? <Button
                        type={"primary"}
                        onClick={onClick}
                    >
                        <ButtonLabel>{applyButtonText}</ButtonLabel>
                    </Button> : null}
            </ButtonGroup>
        </>
    );
};

export default TermsAndConditionsContent;
